import React, { useContext } from "react"
import DispatchContext from "../DispatchContext"

function HeaderLoggedIn(props) {
  const appDispatch = useContext(DispatchContext)
  function handleLogout() {
    appDispatch({ type: "logout" })
    appDispatch({ type: "flashMessage", value: "Successfully logged out!" })
    // localStorage.removeItem("keeperAppToken")
    // localStorage.removeItem("keeperAppUsername")
    // props.addFlashMessage("Successfully logged out!")
  }
  return (
    <form>
      <div>
        <div style={{ margin: " auto -16px", padding: "16px 62px", position: "absolute", top: 10, right: "20px" }}>
          <button onClick={handleLogout} className="btn btn-outline-dark" type="button">
            Logout
          </button>
        </div>
      </div>
    </form>
  )
}

export default HeaderLoggedIn
